import { create } from "zustand";

type EditingState = {
  selected: string | null;
  snapping: boolean;
  dayBounds: boolean;
  graphicsOpacity: number;
  grayscale: boolean;
  renderedPaths: string[];
  livePoint: number[] | null;
  select: (path: string | null) => void;
  setView: (patch: Partial<Pick<EditingState, "snapping" | "dayBounds" | "graphicsOpacity" | "grayscale">>) => void;
};

export const useMetadataEditingStore = create<EditingState>(set => ({
  selected: null,
  snapping: true,
  dayBounds: true,
  graphicsOpacity: 100,
  grayscale: false,
  renderedPaths: [],
  livePoint: null,
  select: selected => set({ selected, livePoint: null }),
  setView: patch => set(patch),
}));
